import React from "react";
import PropTypes from "prop-types";

import Row from "./Row";
import TextInput from "./TextInput";
import DateInput from "./DateInput";
import CheckBoxGroup from "./CheckBoxGroup";


const DatumNVTOptioneel = props => {

	const {
		disabled,
		onChange,
		onCheckboxChange,
		dateError,
		textError,
		checkError,
		dateLabel,
		textLabel,
		checkLabel,
		checkName,
		dateName,
		dateTooltip,
		textName,
		textValue,
		checkValue,
		dateValue,
		checkOptions,
		dateOptional,
		checkOptional,
		textOptional,
		checkInvisible,
		textMaxLength,
		validationMessageType
	} = props;

	function onCheckboxChangeHandler(dateField) {
		return function (event) {
			onCheckboxChange(event, dateField);
		};
	}

	const dateDisabled = disabled || checkValue == false || checkValue == "false";
	const checkboxInvisible = checkInvisible && (checkInvisible == "true" || checkInvisible === true) ? true : false;
	return (
		<Row>
			<DateInput
				size={4}
				label={dateLabel}
				name={dateName}
				value={dateValue}
				validationMessage={dateError}
				validationMessageType={validationMessageType}
				onChange={onChange}
				optional={dateOptional}
				disabled={dateDisabled}
				tooltip={dateTooltip}
			/>
			{checkboxInvisible ?
				null
				:
				<CheckBoxGroup
					size={4}
					label={checkLabel}
					name={checkName}
					value={checkValue}
					validationMessage={checkError}
					validationMessageType={validationMessageType}
					onChange={onCheckboxChangeHandler(dateName)}
					optional={checkOptional}
					disabled={disabled}
					items={checkOptions}
				/>
			}

			<TextInput
				label={textLabel}
				name={textName}
				value={textValue}
				validationMessage={textError}
				validationMessageType={validationMessageType}
				onChange={onChange}
				optional={textOptional}
				disabled={disabled}
				size={checkboxInvisible ? 8 : 4}
				maxLength={textMaxLength}
			/>
		</Row>
	);
};

DatumNVTOptioneel.propTypes = {
	onChange: PropTypes.func,
	onCheckboxChange: PropTypes.func,
	dateName: PropTypes.string,
	dateLabel: PropTypes.string,
	dateValue: PropTypes.string,
	dateError: PropTypes.string,
	dateOptional: PropTypes.bool,
	dateTooltip: PropTypes.string,
	checkName: PropTypes.string,
	checkLabel: PropTypes.string,
	checkValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	checkError: PropTypes.string,
	checkOptional: PropTypes.bool,
	textName: PropTypes.string,
	textLabel: PropTypes.string,
	textValue: PropTypes.string,
	textError: PropTypes.string,
	textOptional: PropTypes.bool,
	disabled: PropTypes.bool,
	checkOptions: PropTypes.arrayOf(PropTypes.object),
	checkInisible: PropTypes.bool,
	checkInvisible: PropTypes.bool,
	textMaxLength: PropTypes.number,
	validationMessageType: PropTypes.string
};

export default DatumNVTOptioneel;
